import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

export function getSimilarArtistsQueryOptions(artistId: string) {
  return deferredResourceQueryOptions(
    orpc.music.getSimilarArtistsResource.queryOptions({ input: { id: artistId } }),
  );
}
